import { render, staticRenderFns } from "./PricesInfo.vue?vue&type=template&id=e11efe3e&"
import script from "./PricesInfo.vue?vue&type=script&lang=js&"
export * from "./PricesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports